// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgPosition = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2.25a.75.75 0 0 1 .75.75v1.286a7.75 7.75 0 0 1 6.963 6.964H21a.75.75 0 0 1 0 1.5h-1.287a7.75 7.75 0 0 1-6.963 6.963V21a.75.75 0 0 1-1.5 0v-1.287a7.75 7.75 0 0 1-6.963-6.963H3a.75.75 0 0 1 0-1.5h1.287a7.75 7.75 0 0 1 6.963-6.964V3a.75.75 0 0 1 .75-.75m0 3.5a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5"
    />
  </svg>
);
export const PositionIcon = forwardRef(SvgPosition);
